export const transformTimesheetMemberRow = timesheetMemberRowData => {
  return {
    ...timesheetMemberRowData,
    timesheet: {
      id: timesheetMemberRowData.timesheetId,
      accountName: timesheetMemberRowData.accountName,
      status: timesheetMemberRowData.status,
      venueId: timesheetMemberRowData.venueId
    },
    role: {
      id: timesheetMemberRowData.roleId,
      name: timesheetMemberRowData.roleName
    },
    venue: timesheetMemberRowData.venueId
      ? {
          id: timesheetMemberRowData.venueId,
          name: timesheetMemberRowData.venueName
        }
      : null,
    subvenue: timesheetMemberRowData.subvenueId
      ? {
          id: timesheetMemberRowData.subvenueId,
          name: timesheetMemberRowData.subvenueName || "Subvenue"
        }
      : null
  };
};

export const transformVenuesList = (venues, timesheetMemberRowData) => {
  return (
    venues ||
    (timesheetMemberRowData.venueId && timesheetMemberRowData.venueName
      ? [
          {
            id: timesheetMemberRowData.venueId,
            name: timesheetMemberRowData.venueName,
            subvenues: timesheetMemberRowData.subvenueId
              ? [
                  {
                    id: timesheetMemberRowData.subvenueId,
                    name: timesheetMemberRowData.subvenueName || "Subvenue"
                  }
                ]
              : []
          }
        ]
      : [])
  );
};

export const transformBookingTimeData = booking => {
  let { startFinal, endFinal } = booking.bookingState;
  let lengthFinal = booking.bookingState.lengthFinal;
  let breakFinal = booking.bookingState?.breakFinal;

  if (booking.timesheetMemberRow?.id) {
    const {
      totalMinutes,
      breakMinutes,
      scheduledStartTime,
      scheduledEndTime
    } = booking.timesheetMemberRow;

    startFinal = scheduledStartTime;
    endFinal = scheduledEndTime;
    lengthFinal = totalMinutes;
    breakFinal = breakMinutes;
  }

  return { startFinal, endFinal, lengthFinal, breakFinal };
};

export const formatTimesheetDuration = (totalMinutes, breakMinutes) => {
  const totalHours = Math.floor((totalMinutes || 0) / 60);
  const totalMins = (totalMinutes || 0) % 60;
  const breakText = breakMinutes ? ` ${breakMinutes}mins break` : " No break";

  return {
    hoursDisplay: `${totalHours}:${totalMins.toString().padStart(2, "0")}h`,
    breakText
  };
};
